import { createReducer } from 'redux-create-reducer';

import { SELECT_LOCALE } from '../actions';

const initialState = { locale: navigator.language };

const events = {
  [SELECT_LOCALE]: (state, action) => ({
    ...state,
    locale: action.locale,
  }),
};
export default createReducer(initialState, events);
